// ============================================================================
// authMediaUrl — attach the JWT to media/report URLs that can't send a header.
// ============================================================================
// Media streaming endpoints (photos, checklist files, BAST, pengesahan dokumen)
// and the HTML/PDF report previews are consumed by plain <img src="..."> tags
// and window.open(...), neither of which can attach an Authorization header.
// The backend (auth_utils.require_user_or_query_token) therefore also accepts
// the token as a `?token=<jwt>` query param. This helper appends it while
// preserving any existing query string (e.g. ?v=<version> / ?thumb=1).
//
// TRADEOFF: a JWT placed in the URL is captured by web-server / proxy access
// logs. This is accepted as strictly better than the previous posture (fully
// anonymous media/report reads); the token carries the normal 24h TTL. A
// short-lived, media-scoped token is a future improvement.
export function authMediaUrl(url) {
  if (!url) return url;
  // Utamakan token MEDIA (scope="media", 30 hari): stabil antar login sehingga
  // URL <img> tidak berubah dan cache foto browser tetap berlaku. Fallback ke
  // token sesi untuk masa transisi (login lama belum punya media_token).
  const token = localStorage.getItem("media_token") || localStorage.getItem("token");
  if (!token) return url;
  const sep = url.includes("?") ? "&" : "?";
  let hasil = `${url}${sep}token=${encodeURIComponent(token)}`;
  // Satker Aktif (act-as) super-admin: URL yang dibuka via window.open tak bisa
  // mengirim header X-Satker-Aktif, jadi dititip di query `sa` agar laporan/PDF
  // ikut ter-scope ke satker terpilih.
  try {
    const sa = localStorage.getItem("satker_aktif");
    if (sa) hasil += `&sa=${encodeURIComponent(sa)}`;
  } catch { /* localStorage tak tersedia */ }
  return hasil;
}
